"use client";

import React from "react";

import CloseButton from "@/components/flowbite/button/close-button";
import Typography from "@/components/flowbite/typography/typography";

interface DetailsPanelHeaderProps {
  title: string;
  onClose: () => void;
}

export const DetailsPanelHeader: React.FC<DetailsPanelHeaderProps> = ({
  title,
  onClose,
}) => {
  return (
    <div className="flex shrink-0 items-start justify-between gap-2 rounded-t-xl border-b border-gray-200 bg-white p-3">
      <Typography.H5
        className="min-w-0 flex-1 truncate"
        colorShade={500}
      >
        {title}
      </Typography.H5>
      <CloseButton
        className="shrink-0"
        onClose={onClose}
      />
    </div>
  );
};
